import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";

import DataCleansing from "components/CreateWizard/Dataset/DataCleansing";

const bId = "dataCleansing";

class DataCleansingContainer extends React.PureComponent {
  render() {
    const { step, index, transformUpdateDataset } = this.props;

    return <DataCleansing {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => {
  return {
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(DataCleansingContainer);
